// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LarCognitoforms_wrapper__3NSOr"};